import { configureStore } from "@reduxjs/toolkit";
import searchResultsReducer from "../slices/searchResultsSlice";
import recommendedIntegrationsReducer from "../slices/recommendedIntegrationsSlice";
import integrationGoalsReducer from "../slices/goalsSlice";
import optionsReducer from "../slices/optionsSlice";
import { persistStore, persistReducer } from 'redux-persist';
import expireIn from "redux-persist-transform-expire-in";
import storage from "redux-persist/lib/storage";
import { thirtyDaySeconds } from "../components/Constants";

const expireInTime = thirtyDaySeconds;
const expirationKey = "expirationKey";
const persistConfigSearchResults = {
  key: "v1",
  storage,
  transforms: [expireIn(expireInTime, expirationKey, [])]
};

const persistConfigIntegrationGoals = {
    key: "v2",
    storage,
    transforms: [expireIn(expireInTime, expirationKey, [])]
};

const searchResultsPersistedReducer = persistReducer(
    persistConfigSearchResults, searchResultsReducer
);

const integrationGoalsPersistedReducer = persistReducer(
    persistConfigIntegrationGoals, integrationGoalsReducer
);

const store = configureStore({
    reducer: {
        searchResult: searchResultsPersistedReducer,
        recommendedIntegrations: recommendedIntegrationsReducer,
        integrationGoals: integrationGoalsPersistedReducer,
        options: optionsReducer
    }
})

export default store;

export const persistor = persistStore(store);